// @flow
'use strict';

import * as React from 'react';

import type { IPisStPerc } from '../../../../../types_imposto';

import RowDetalhes from '../../../../../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../../../../../common/detalhes_documento/column_detalhes';

type PisStPercProps = {
  item : IPisStPerc,
};

export default function PisStPerc({ item } : PisStPercProps) {
  return (
      <RowDetalhes data={ item }>
        <ColumnDetalhes field="valorBc" type="moeda" width="25%">Base de Cálculo do PIS</ColumnDetalhes>
        <ColumnDetalhes field="aliquota" type="percentual" width="25%">Alíquota do PIS</ColumnDetalhes>
      </RowDetalhes>
  );
}
